
export class college {
    id:number;
    collegeName :string;
    universityId :number=1;
    }